import React from 'react';
import clsx from 'clsx';
// material ui
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
// components
import Theme from '../../Theme.js';
// variables
import { layoutVariables } from '../helpers.js'


const headerStyles = makeStyles({
  desktop: {
    top: '0',
    left: '0',
    zIndex: '1',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid rgba(0,0,0,.0975);',
    '&.live': {
      position: 'fixed',
    },
    '&.builder': {
      // position: 'absolute',
      margin: '0 -10px',
      position: 'static',
      width: 'auto',
    },
    '& > .header__container': {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '1010px',
      padding: '26px 20px',
    },
    '& .header__img': {
      height: '36px',
    },
    '& .header__text': {
      fontSize: '1.3rem',
      color: Theme.palette.text.primary,
    },
  },
  mobile: {
    top: '0',
    left: '0',
    zIndex: '1',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid rgba(0,0,0,.0975);',
    '&.live': {
      position: 'fixed',
    },
    '&.builder': {
      position: 'absolute',
    },
    '& > .header__container': {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '1010px',
      padding: layoutVariables.mobileHeaderImgPadding + 'px',
    },
    '& .header__img': {
      height: layoutVariables.mobileHeaderImgHeight + 'px',
    },
    '& .header__text': {
      color: Theme.palette.text.primary,
    },
  },
});

export default function Header(props) {
  const logo = window.logo;
  const logoOrName = window.logoOrName;
  const mode = window.mode;
  const classes = headerStyles();

  const headerClasses = clsx({
    [classes.desktop] : props.device == 'desktop' ? true : false,
    [classes.mobile] : props.device == 'mobile' ? true : false,
    [mode]: true,
    'mui-fixed': true,
  })

  return (
    <Box id="header" className={headerClasses} >
      <Box className="header__container">
        {logoOrName == 'logo' ? (
          <Box className="header__img">
            <img src={logo} height="100%" />
          </Box>
        ) : (
          <Typography variant="body1" component="span" className="header__text" >
            {logo}
          </Typography>
      )}
      </Box>
    </Box>
  )
}
  